import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useApp } from "../context/AppContext";
import { Trash2 } from "lucide-react";

export default function Cart() {
  const { cart, updateQty, removeFromCart, user } = useApp();
  const nav = useNavigate();
  const total = cart.reduce((s,x)=>s+x.price*x.qty,0);
  return (
    <div className="max-w-5xl mx-auto px-6 py-10" data-testid="cart-page">
      <h1 className="font-display text-5xl mb-8">YOUR CART</h1>
      {cart.length === 0 ? (
        <div className="text-center py-20" data-testid="empty-cart"><p className="font-mono mb-6">Cart is empty.</p><Link to="/shop" className="btn-primary">BROWSE INVENTORY</Link></div>
      ) : (
        <div className="grid md:grid-cols-3 gap-8">
          <div className="md:col-span-2 space-y-4">
            {cart.map(i => (
              <div key={i.product_id} className="card-industrial p-4 flex gap-4 items-center" data-testid={`cart-item-${i.product_id}`}>
                <img src={i.image} className="w-24 h-24 object-cover border-2 border-[var(--ink)]"/>
                <div className="flex-1">
                  <div className="font-display text-lg">{i.name}</div>
                  <div className="font-mono text-sm">${i.price.toFixed(2)} each</div>
                </div>
                <input type="number" min="1" value={i.qty} onChange={e=>updateQty(i.product_id, parseInt(e.target.value)||1)} className="input-field w-20 text-center" data-testid={`qty-${i.product_id}`}/>
                <div className="font-display text-xl w-20 text-right">${(i.price*i.qty).toFixed(2)}</div>
                <button onClick={()=>removeFromCart(i.product_id)} className="p-2 hover:text-[var(--accent)]" data-testid={`remove-${i.product_id}`}><Trash2 size={18}/></button>
              </div>
            ))}
          </div>
          <div className="card-industrial p-6 h-fit">
            <h2 className="font-display text-2xl mb-4 border-b-2 border-[var(--ink)] pb-2">SUMMARY</h2>
            <div className="flex justify-between mb-2 font-mono"><span>Subtotal</span><span>${total.toFixed(2)}</span></div>
            <div className="flex justify-between mb-4 font-mono text-xs text-[var(--ink-2)]"><span>Pickup</span><span>FREE</span></div>
            <div className="flex justify-between mb-6 font-display text-2xl border-t-2 border-[var(--ink)] pt-3"><span>TOTAL</span><span data-testid="cart-total">${total.toFixed(2)}</span></div>
            <button onClick={()=>nav(user?"/checkout":"/login")} className="btn-primary w-full" data-testid="checkout-btn">{user?"CHECKOUT":"SIGN IN TO CHECKOUT"}</button>
          </div>
        </div>
      )}
    </div>
  );
}
